import { Cache } from './Cache.js';

export class Storage {

    constructor() {

        if (this.$initialized)
            return;

        this.cache = new Cache();
        this.session = {};

        this.$initialized = true;

        return this;

    };

    async prepare() {

        return true;

    };

    // --------------------------------------------------------------------

    createSlot(slotName, persistent = false, expiresIn = 300) {

        return this.cache.getOrCreateSlot(slotName, persistent, expiresIn);

    };

    // --------------------------------------------------------------------

    async loadData(slotName, endpointUrl, authManager, forceReload = false) {

        return this.cache.loadData(slotName, endpointUrl, authManager, forceReload);

    };

    async loadModelData(slotName, datamodel, query) {

        this.cache.createSlot(slotName);

        let dataset = await datamodel.queryData(query);

        this.cache.setData(slotName, dataset.data);

        return true;

    };

    getData(slotName) {

        return this.cache.getData(slotName);

    };

    setData(slotName, data) {

        return this.cache.setData(slotName, data);

    };

    // --------------------------------------------------------------------

}

export const instance = new Storage();